//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "editComment",
  props: {
    mentData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      ruleForm: {
        radio: "",
        radio1: "",
        checkList: [],
        radio3: ""
      },
      ruleValidate: {
        type: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 80,
          message: "长度在 1 到 80 个字符",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 80,
          message: "长度在 1 到 80 个字符",
          trigger: "blur"
        }]
      } // 表单验证

    };
  },
  mounted: function mounted() {},
  methods: {
    submitForm: function submitForm() {
      this.$refs["ruleForm"].validate(function (valid) {
        if (valid) {// addObj(this.formValidate).then(res => {
          //     if (res.data.code == 0) {
          //         this.subDisabled = false;
          //         this.$refs[formName].resetFields();
          //         this.closeModal()
          //     } else {
          //         this.subDisabled = false;
          //         this.$alert(res.data.msg, '提示', {
          //             confirmButtonText: '确定',
          //             type: 'warning'
          //         });
          //     }
          // })
        }
      });
    },
    closeModal: function closeModal() {
      this.mentData.state = false;
    }
  }
};